import React from 'react'
import { StyleSheet, Text, View } from "@react-pdf/renderer";
const styles = StyleSheet.create({
    footer: {
        height: 50,
        marginTop: 20,
        color: '#ccc',
        textAlign: 'center',
    },
});
const Footer = () => {
    return (
        <View style={styles.footer}>
            <Text>If you are face any problem to plan your event, You may contact to our customer support at +918188088879</Text>
            <Text>
                Powered by Event Planet 2025
            </Text>
        </View>
    )
}

export default Footer